export default {
  enterValid: 'Please enter the valid',
  pageName: 'Page name',
  pageNamePlaceholder: 'Enter page name',
  createNewPage: 'Create new page',
  editPage: 'Editpage',
  subDomain: 'Subdomain',
  subDomainPlaceholder: 'Enter Subdomain i.e goods,books,architectures etc.',
  profix: 'Profix',
  pageTypePlaceholder: 'Select Page type',
  createMember: 'Add new member',
  firstName: 'First Name',
  lastName: 'Last Name',
  emailPlaceholder: 'Enter email address',
  password: 'Password',
  avatar: 'avatar',
  userName: 'Username',
  role: 'Select Role',
  roleError: 'Please select a role',
  createTeam: 'Create new team',
  id: 'ID',
  team: 'Team',
  manager: 'Manager',
  countries: 'Countries',
  search: 'Search',
  groups: 'Groups',
  allAdmin: 'All Admin',
  pending: 'Pending',
  active: 'Active',
  partners: 'Partners',
  former: 'Member Former',
  memberNow: 'Member Now',
  partnerId: 'PARTNER ID',
  country: 'COUNTRY',
  companyName: 'COMPANY NAME',
  group: 'GROUP',
};
